import { render, staticRenderFns } from "./GeneralInfoClient.vue?vue&type=template&id=6721dbe8&scoped=true"
import script from "./GeneralInfoClient.vue?vue&type=script&lang=js"
export * from "./GeneralInfoClient.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoClient.vue?vue&type=style&index=0&id=6721dbe8&prod&lang=scss&scoped=true"
import style1 from "./GeneralInfoClient.vue?vue&type=style&index=1&id=6721dbe8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6721dbe8",
  null
  
)

export default component.exports